import { withParams, ref } from 'vuelidate/lib/validators/common';

export var onlyLetters = function onlyLetters(otherProp) {
    return withParams({ type: otherProp }, function (value) {
        return (/^[a-zA-Z ]*$/.test(value)
        );
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/validators/only-letters.js
// module id = ./src/validators/only-letters.js
// module chunks = 0 1 2 3 4 6 7 8 9 10 11 12 14 15 16